export function areArraysEqual<V>(arrA: V[], arrB: V[]) {
  if (arrA === arrB) {
    return true;
  }

  if (arrA.length !== arrB.length) {
    return false;
  }

  for (let i = 0; i < arrA.length; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
}
